import { FETCH_AUDIT, FETCH_AUDIT_DATA, FETCH_AUDIT_ERROR } from './constants';

const initialState = {
    list: {
        data: [],
        hasError: false,
        isLoading: false,
    },
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_AUDIT:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_AUDIT_DATA:
            return {
                ...state,
                list: {
                    data: payload,
                    hasError: false,
                    isLoading: false,
                },
            };
        case FETCH_AUDIT_ERROR:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: true,
                    isLoading: false,
                },
            };

        default:
            return state;
    }
};

export default reducer;
